import type { Facing, MoveFailure, MoveResult, MoveSuccess } from "@tgame-001/shared-types";
import { apiPost } from "./client";

export type { Facing, MoveSuccess, MoveFailure, MoveResult };

export async function move(dx: -1 | 0 | 1, dy: -1 | 0 | 1): Promise<MoveResult> {
  // Backend zwraca 422 z {ok:false,...} dla failed action — ApiError tym razem nie rzucamy,
  // bo MoveFailure to walid response (gracz po prostu nie moze isc tam).
  // Trick: 422 ma w body { ok: false, code, error } — apiPost rzuci ApiError, ale jego
  // body wlasnie to. Robimy manual fetch zeby zwrocic typed result zamiast throw.
  try {
    return await apiPost<MoveSuccess>("/api/movement/move", { dx, dy });
  } catch (err) {
    if (
      err &&
      typeof err === "object" &&
      "status" in err &&
      (err as { status: number }).status === 422 &&
      "body" in err
    ) {
      return (err as { body: MoveFailure }).body;
    }
    throw err;
  }
}
